import type { ColDef } from 'ag-grid-community';
import { mountGrid } from '../components/DataGrid';
import type { AppData, MetricRow } from '../data/types';

const dashTypeColors: Record<string, string> = {
  Behavior: 'bg-violet-100 text-violet-700',
  Compliance: 'bg-amber-100 text-amber-700',
  Historical: 'bg-blue-100 text-blue-700',
  Monitoring: 'bg-emerald-100 text-emerald-700',
  Operational: 'bg-cyan-100 text-cyan-700',
  Strategic: 'bg-rose-100 text-rose-700',
};

export function renderInventario(container: HTMLElement, data: AppData): void {
  const columnDefs: ColDef<MetricRow>[] = [
    { field: 'Category', headerName: 'Categoría', width: 140, enableRowGroup: true, pinned: 'left' },
    { field: 'VieSuite', headerName: 'Vie Suite', width: 170, enableRowGroup: true },
    { field: 'VieProduct', headerName: 'Vie Product', width: 140, enableRowGroup: true },
    { field: 'Product', headerName: 'Producto', width: 160, enableRowGroup: true },
    { field: 'Module', headerName: 'Módulo', width: 240, enableRowGroup: true },
    {
      field: 'DashboardType',
      headerName: 'Tipo',
      width: 130,
      enableRowGroup: true,
      cellRenderer: (p: any) => {
        const v = String(p.value || '');
        const cls = dashTypeColors[v] || 'bg-slate-100 text-slate-700';
        return v ? `<span class="badge ${cls}">${v}</span>` : '';
      },
    },
    { field: 'KPIDescription', headerName: 'KPI', width: 350, tooltipField: 'KPIDescription' },
    { field: 'OwnerCargo', headerName: 'Owner (Cargo)', width: 240, enableRowGroup: true },
    { field: 'FichaTecnica', headerName: 'Ficha ID', width: 140, cellClass: 'font-mono text-xs' },
    { field: 'Accion', headerName: 'Acción', width: 130 },
    { field: 'TiempoData', headerName: 'T. Data', width: 90 },
    { field: 'CheckData', headerName: 'Check Data', width: 110 },
    { field: 'TiempoBI', headerName: 'T. BI', width: 80 },
    { field: 'CheckBI', headerName: 'Check BI', width: 110 },
    { field: 'Observaciones', headerName: 'Obs', width: 280, tooltipField: 'Observaciones' },
  ];

  mountGrid<MetricRow>({
    container,
    rowData: data.metrics,
    columnDefs,
    exportFilename: 'inventario-metricas.csv',
    quickFilterPlaceholder: 'Buscar producto, módulo, KPI, owner…',
  });
}
